import React from 'react';
import SimpleDataTable from '../Tables/Simple/SimpleDataTable';

interface Props {
  data: {
    id: number;
    documentName: string | null;
    testType: string;
    requiredCount: number;
    active: boolean;
  }[];
}

const TestRequirementsTable: React.FC<Props> = ({ data }) => {
  return (
    <SimpleDataTable
      title="Documentos y Cantidades Requeridas por MH"
      description="Listado oficial de documentos y pruebas requeridas por el Ministerio de Hacienda para habilitar la emisión DTE."
      columns={[
        { key: 'documentName', label: 'Documento', span: 3 },
        { key: 'testType', label: 'Tipo de Prueba', span: 2 },
        { key: 'requiredCount', label: 'Cantidad', span: 1 },
      ]}
      data={data}
      emptyMessage="No hay requisitos configurados."
    />
  );
};

export default TestRequirementsTable;
